<p>2024</p>
<p>An ongoing series of satirical slimes, which can be purchased on Etsy if you don’t mind mold.</p>
<app-project-gallery [galleryItems]="galleryItems"></app-project-gallery>